var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyTaskIlls(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 125,
    viewBox: "0 0 192 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40332 30.0684V63.0499",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10521 65.8587C14.3973 65.8587 24.6895 65.8587 34.9816 65.8587C40.7289 65.8587 46.2656 64.675 51.9792 64.4552C58.1125 64.2193 52.7197 42.2326 51.8232 37.7503C51.3909 35.5886 50.4198 33.7049 50.4198 31.4736C50.4198 30.1875 51.0071 27.4138 50.3418 26.2496C49.2744 24.3816 36.8024 25.8598 34.7867 25.8598C27.4859 25.8598 20.6726 25.7 13.6176 27.1853C9.97901 27.9513 5.73889 27.965 2 27.965",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40332 87.3027V120.284",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.995 87.3027V120.284",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.995 24.3027V57.2843",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9951 87.3027V120.284",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9951 27.3027V60.2843",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10521 123.093C14.3973 123.093 24.6895 123.093 34.9816 123.093C40.7289 123.093 46.2656 121.909 51.9792 121.69C58.1125 121.454 52.7197 99.467 51.8232 94.9847C51.3909 92.823 50.4198 90.9393 50.4198 88.708C50.4198 87.4219 51.0071 84.6482 50.3418 83.484C49.2744 81.616 36.8024 83.0941 34.7867 83.0941C27.4859 83.0941 20.6726 82.9344 13.6176 84.4196C9.97901 85.1857 5.73889 85.1993 2 85.1993",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.697 123.093C149.989 123.093 160.281 123.093 170.573 123.093C176.321 123.093 181.857 121.909 187.571 121.69C193.704 121.454 188.312 99.467 187.415 94.9847C186.983 92.823 186.012 90.9393 186.012 88.708C186.012 87.4219 186.599 84.6482 185.934 83.484C184.866 81.616 172.394 83.0941 170.378 83.0941C163.078 83.0941 156.264 82.9344 149.209 84.4196C145.571 85.1857 141.331 85.1993 137.592 85.1993",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M139.697 60.0931C149.989 60.0931 160.281 60.0931 170.573 60.0931C176.321 60.0931 181.857 58.9094 187.571 58.6896C193.704 58.4537 188.312 36.467 187.415 31.9847C186.983 29.823 186.012 27.9393 186.012 25.708C186.012 24.4219 186.599 21.6482 185.934 20.484C184.866 18.616 172.394 20.0941 170.378 20.0941C163.078 20.0941 156.264 19.9344 149.209 21.4196C145.571 22.1857 141.331 22.1993 137.592 22.1993",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M71.697 123.093C81.9891 123.093 92.2813 123.093 102.573 123.093C108.321 123.093 113.857 121.909 119.571 121.69C125.704 121.454 120.312 99.467 119.415 94.9847C118.983 92.823 118.012 90.9393 118.012 88.708C118.012 87.4219 118.599 84.6482 117.934 83.484C116.866 81.616 104.394 83.0941 102.378 83.0941C95.0777 83.0941 88.2644 82.9344 81.2094 84.4196C77.5708 85.1857 73.3307 85.1993 69.5918 85.1993",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.697 63.0931C81.9891 63.0931 92.2813 63.0931 102.573 63.0931C108.321 63.0931 113.857 61.9094 119.571 61.6896C125.704 61.4537 120.312 39.467 119.415 34.9847C118.983 32.823 118.012 30.9393 118.012 28.708C118.012 27.4219 118.599 24.6482 117.934 23.484C116.866 21.616 104.394 23.0941 102.378 23.0941C95.0777 23.0941 88.2644 22.9344 81.2094 24.4196C77.5708 25.1857 73.3307 25.1993 69.5918 25.1993",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.751 29.3677C104.468 31.318 109.715 43.5649 111.626 41.2192C115.668 36.2591 117.372 28.4725 119.618 22.5842C122.573 14.8381 126.987 8.64593 131.821 2",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTaskIlls);
export default __webpack_public_path__ + "static/media/emptyTaskIlls.cbc98a8a2614d2d2c65960bb01862174.svg";
export { ForwardRef as ReactComponent };